import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const Meters = lazy(() => import('./Meters'));
const MeterNew = lazy(() => import('./meter/MeterNew'));
const MeterEdit = lazy(() => import('./meter/MeterEdit'));

export const meterRoutes: RouteObject[] = [
  {
    path: 'meters',
    children: [
      { index: true, element: <Meters /> },
      { path: 'new', element: <MeterNew /> },
      { path: ':meterId', element: <MeterEdit /> },
    ],
  },
];
